<template>
  <v-card class="elevation-0">
    <v-card-text :class="wrapperClasses">
      <iframe
        v-show="dialog && !checkingSignature"
        :src="signUrl"
        :id="iframeId"
        width="100%">
      </iframe>
    </v-card-text>
    <v-card-actions v-if="!hideActions">
      <slot/>
      <v-spacer/>
      <v-btn
        :disabled="checkingSignature"
        color="primary"
        flat
        @click.native="$emit('cancel')">
        {{ $t('close') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'SignDocument',

  props: {
    signUrl: String,
    dialog: Boolean,
    wrapperClasses: String,
    iframeId: {
      type: String,
      default: 'isign-gateway-dialog',
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    checkingSignature: Boolean,
  },
};
</script>

<style>
  #isign-gateway-dialog {
    /*min-height: calc(88vh - 105px);*/
    min-height: 80vh;
    border: none;
  }

  #isign-gateway {
    min-height: calc(100vh - 61px);
    border: none;
  }

  .iframe-wrapper {
    /*min-height: calc(88vh - 105px);*/
    min-height: 80vh;
    background: url(../assets/loading-spinner.svg) center center no-repeat;
  }
</style>
